import Vue from "vue"
import FooterNotify from "./index.vue"

const NotifyConstructor = Vue.extend(FooterNotify)

let instance = null
const instances = []

const Notify = function (options) {
  // If an existing notification is present, close it immediately
  if (instance) {
    instance.close()
  }

  // 确保 options 有默认值
  options = {
    message: options.message || "",
    title: options.title || "",
    type: options.type || "info",
    duration: options.duration || 5000
  }

  const userOnClose = options.onClose

  const id = "footer-notify-" + Date.now()

  options.onClose = function () {
    Notify.close(id, userOnClose)
  }

  instance = new NotifyConstructor({
    propsData: options
  })

  instance.id = id
  instance.$mount()
  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.show()
  })

  return instance
}

Notify.close = function (id, userOnClose) {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      if (typeof userOnClose === "function") {
        userOnClose(instances[i])
      }
      instances.splice(i, 1)
      break
    }
  }
}

Notify.closeAll = function () {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close()
  }
}

export default Notify
